import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { CanvasNode } from "@opus-dt/shared-types";

interface FormProps {
  node: CanvasNode;
  onChange: (next: Partial<CanvasNode>) => void;
}

export function EquipmentForm({ node, onChange }: FormProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor="subtype">Subtipo</Label>
      <Input
        id="subtype"
        placeholder="conveyor, tank, hopper…"
        value={(node.data?.subtype as string) ?? ""}
        onChange={(e) => onChange({ data: { ...node.data, subtype: e.target.value } })}
      />
    </div>
  );
}

export function CheckpointForm({ node, onChange }: FormProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor="check-type">Tipo de checagem</Label>
      <Input
        id="check-type"
        placeholder="visual, métrica, sensorial…"
        value={(node.data?.checkType as string) ?? ""}
        onChange={(e) => onChange({ data: { ...node.data, checkType: e.target.value } })}
      />
    </div>
  );
}

export function HumanStepForm({ node, onChange }: FormProps) {
  return (
    <>
      <div className="space-y-1.5">
        <Label htmlFor="role">Papel</Label>
        <Input
          id="role"
          placeholder="operador, técnico, supervisor…"
          value={(node.data?.role as string) ?? ""}
          onChange={(e) => onChange({ data: { ...node.data, role: e.target.value } })}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="description">Descrição</Label>
        <Input
          id="description"
          value={(node.data?.description as string) ?? ""}
          onChange={(e) => onChange({ data: { ...node.data, description: e.target.value } })}
        />
      </div>
    </>
  );
}
